export enum PaymentRequirementDraftCheque {
	None = 'None',
	Optional = 'Optional',
	Required = 'Required'
}